var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSliderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 11,
    viewBox: "0 0 70 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#bc9876",
    d: "M34.13 5.5c0 3.028-2.488 5.5-5.535 5.5S23.06 8.528 23.06 5.5 25.548 0 28.595 0s5.535 2.472 5.535 5.5zm-1.314 0c0-2.306-1.9-4.194-4.22-4.194-2.321 0-4.222 1.888-4.222 4.194s1.9 4.194 4.221 4.194c2.32 0 4.221-1.888 4.221-4.194z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#bc9876",
    d: "M5.535 9.694c-2.32 0-4.221-1.888-4.221-4.194s1.9-4.194 4.221-4.194c1.174 0 2.209.472 2.991 1.222l.923-.917A5.508 5.508 0 0 0 5.535 0C2.488 0 0 2.472 0 5.5S2.488 11 5.535 11A5.508 5.508 0 0 0 9.45 9.389l-.923-.917c-.782.75-1.817 1.222-2.99 1.222z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#bc9876",
    d: "M45.655 9.694c-2.32 0-4.221-1.888-4.221-4.194s1.9-4.194 4.221-4.194c1.174 0 2.209.472 2.991 1.222l.923-.917A5.508 5.508 0 0 0 45.655 0c-3.047 0-5.535 2.472-5.535 5.5s2.488 5.5 5.535 5.5a5.508 5.508 0 0 0 3.914-1.611l-.923-.917a4.238 4.238 0 0 1-2.99 1.222z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#bc9876",
    d: "M13.164.31H11.85v10.417h1.314z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#bc9876",
    d: "M37.794 3.56H36.48v7.167h1.314z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#bc9876",
    d: "M20.914.31H19.6v10.417h1.314z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#bc9876",
    d: "M20.264 4.83H12.52v1.306h7.744z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#bc9876",
    d: "M58.93 9.39h-6.29v1.306h6.29z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#bc9876",
    d: "M58.93.31h-6.29v1.306h6.29z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#bc9876",
    d: "M37.126 2.504L34.89.31h4.473z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#bc9876",
    d: "M54.565 5.723c0 .584-.391.945-.922.945-.532 0-.923-.334-.923-.945V4.39h.363v1.361c0 .389.252.583.56.583.307 0 .559-.194.559-.583V4.39h.363z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#bc9876",
    d: "M55.69 6.642h.363V4.42h-.363zm.867-1.194l.922-1.028h-.447l-.95 1.028 1.034 1.194h.447z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#bc9876",
    d: "M59.876 6.642l-.643-.86h-.42v.86h-.363V4.42h.81c.448 0 .755.278.755.694a.673.673 0 0 1-.419.64l.671.916h-.391zM58.84 5.448h.448c.251 0 .391-.14.391-.361 0-.223-.14-.361-.391-.361h-.448z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#bc9876",
    d: "M62.535 6.249H61.53l-.168.361h-.391l.978-2.25h.112l.979 2.25h-.392zm-.503-1.222l-.363.916h.755z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#bc9876",
    d: "M64.383 6.642h-.363V4.42h.363z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#bc9876",
    d: "M67.345 4.416v2.25h-.112l-1.37-1.556v1.5H65.5V4.36h.112l1.37 1.528v-1.5h.363z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#bc9876",
    d: "M69.972 4.726h-1.119v.583h.84v.305h-.84v.695H70v.333h-1.51V4.42h1.482z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderLogo);
export default __webpack_public_path__ + "static/media/slider_logo.d25c4452c31aad0efdbd59034344fa67.svg";
export { ForwardRef as ReactComponent };